const spMenu = {
  namespaced: true,
  state: {
    activeMenu: false,
    scrollY: 0 // ios11バグ対応で使用。関連箇所は、index.vueのisIOSとshowModalとcloseElement。
  },
  getters: {
    getActiveMenu: (state) => state.activeMenu,
    getScrollY: (state) => state.scrollY
  },
  mutations: {
    setActiveMenu (state, activeMenu) {
      state.activeMenu = activeMenu
    },
    setScrollY (state, scrollY) {
      state.scrollY = scrollY
    }
  },
  actions: {
    setActiveMenu ({ commit }, activeMenu) {
      commit('setActiveMenu', activeMenu)
    },
    setScrollY ({ commit }, scrollY) {
      commit('setScrollY', scrollY)
    }
  }
}

export default spMenu



// WEBPACK FOOTER //
// ./src/vuex/spMenu.js